import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {EditPermissions} from '../../../../../../../shared/models';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {required} from '../../../../../../../shared/utils';
import map from 'lodash/map';

export class MenuFormNode {
    menu: any = {};

    constructor(nodeType: string) {
        this.menu = {
            'menuType': nodeType,
        };
    }

    static toForm(stepData: { [index: string]: any }) {
        return {
            menuParams: this.menuParamsForm(stepData)
        };
    }

    static menuParamsForm(stepData) {
        const menu = stepData?.menu;
        return {
            imageRef: menu?.imageRef ? menu.imageRef : '',
            menuHeader: menu?.menuHeader ? menu.menuHeader : '',
            isPrivateVariable: menu?.input && menu?.input.isPrivateVariable ? menu.input.isPrivateVariable : false,
            subHeader: menu?.menuParams && menu?.menuParams.subHeader ? menu.menuParams.subHeader : '',
            showPageResults: menu?.menuParams && menu?.menuParams.showPageResults ? menu.menuParams.showPageResults : false,
            invalidInputText: menu?.menuParams && menu?.menuParams.invalidInputText ? menu.menuParams.invalidInputText : '',
            varName: menu?.input && menu?.input.varName ? menu.input.varName : '',
            next: stepData?.next ? stepData.next : newStepValue
        };
    }

    static getMenuTemplate(editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new UntypedFormGroup({
            imageRef: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('Image')]),
            configureForm: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('A configured form')]),
            menuHeader: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('Form header')]),
            isPrivateVariable: new UntypedFormControl({
                value: false,
                disabled: !editFlows
            }),
            showPageResults: new UntypedFormControl({
                value: false,
                disabled: !editFlows
            }),
            subHeader: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }),
            invalidInputText: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }),
            varName: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }, [required('A variable name')]),
            next: new UntypedFormControl({
                value: '',
                disabled: !editFlows
            }),
        });
    }

    addMenuParams(params): void {
        const { imageRef, menuHeader, isPrivateVariable, showPageResults, subHeader, invalidInputText, varName } = params;

        const input = this.menu.input ? this.menu.input : {};
        const menuParams = this.menu.menuParams ? this.menu.menuParams : {};

        this.menu = {
            ...this.menu,
            imageRef,
            menuHeader,
            input: {
                ...input,
                isPrivateVariable,
                varName
            },
            menuParams: {
                ...menuParams,
                subHeader,
                showPageResults,
                invalidInputText
            }
        };
    }

    addPages(pagesList): void {
        const pages = map(pagesList, (page, index) => {
            page.order = index;
            if (page.hasOwnProperty('valid')) {
                delete page.valid;
            }
            return page;
        });
      this.menu.menuParams['pages'] = pages;
    }

    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            'next': newStepValue,
            metadata: {
                nodeVersion: '1.2.0'
            }
        };
    }
}
